import { Box } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import theme from "src/theme/light"

const useStyles = makeStyles({
  list: {
    lineHeight: '1.5rem',
    color: '#00000099',
    textAlign: 'left',
    paddingLeft: '16px'
  },
  listItem: {
    marginBottom: "5px"
  }
})

export const OrientacoesDimensionado = () => {
  const classes = useStyles()
  
  return (
    <Box>
      <Box p={2}>
        <Box borderRadius="8px" p={2} width='100%' height={"auto"} bgcolor={theme.palette.grey[200]}>
          <Box display="block" width="100%" textAlign={"left"} component="span" fontSize={18} fontWeight={500} color={theme.palette.primary.main}>Orientações de Dimensionamento</Box>
            <ol className={classes.list}>
              <li className={classes.listItem}>O projeto Off Grid fornece o dimensionamento adequado para as cargas informadas, considerando condições normais de uso. No entanto, fatores externos podem comprometer o funcionamento do sistema, como a inclusão de cargas ou consumos não cadastrados, aumento do uso diário, excesso de dias chuvosos, acúmulo de sujeira nos módulos ou instalações incorretas.</li>
              <li className={classes.listItem}>Para ligação dos equipamentos do sistema, é necessário que calcule corretamente os cabos. Na dúvida, consulte o datasheet e o manual dos equipamentos.</li>
              <li className={classes.listItem}>Para projetos com motor de indução, verifique se a potência e a corrente de partida do motor não ultrapassam a potência máxima de pico e a corrente suportada pelo inversor recomendado. Em caso de dúvida, consulte o manual dos equipamentos.</li>
              <li className={classes.listItem}>A autonomia informada é calculada em horas, e o dimensionamento é feito a partir da média de consumo diário (Wh/dia). Caso o consumo noturno seja maior que o consumo diurno, ou se a carga tiver tempo de consumo superior a 3 horas, recomenda-se escolher uma autonomia maior, compatível com a necessidade de descarga instantânea.</li>
              <li className={classes.listItem}>A durabilidade da bateria depende de fatores como a temperatura do ambiente de instalação, profundidade de descarga, ciclagem, potências instantâneas, descargas com corrente acima do recomendado e os materiais que compõem a bateria. Em caso de dúvida, consulte o manual do produto.</li>
            </ol>
          </Box>
        </Box>
      <Box/>
    </Box>
  );
}